module.exports = __webpack_public_path__ + "static/media/recentp1.75585fa1.png";